import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { ArrowLeft, User, Users, Palette, Key } from 'lucide-react';

const SettingsSidebar: React.FC = () => {
  const navigate = useNavigate();

  return (
    <aside className="settings-sidebar">
      <div className="settings-sidebar-content">
        <div className="settings-page-header">
          <button className="settings-back-btn" onClick={() => navigate('/dashboard')} title="Back to Dashboard">
            <ArrowLeft size={20} />
          </button>
          <h1 className="settings-page-title">Settings</h1>
        </div>
        
        <NavLink 
          to="/settings/whitelabel" 
          className={({ isActive }) => `settings-nav-item ${isActive ? 'active' : ''}`}
        >
          <Palette size={18} />
          <span>White Labeling</span>
        </NavLink>

        <NavLink 
          to="/settings/change-password" 
          className={({ isActive }) => `settings-nav-item ${isActive ? 'active' : ''}`}
        >
          <Key size={18} />
          <span>Change Password</span>
        </NavLink>
      </div>
    </aside>
  );
};

export default SettingsSidebar;
